import { render, staticRenderFns } from "./RegulationsDialog.vue?vue&type=template&id=42173c67&scoped=true&"
import script from "./RegulationsDialog.vue?vue&type=script&lang=ts&"
export * from "./RegulationsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RegulationsDialog.vue?vue&type=style&index=0&id=42173c67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42173c67",
  null
  
)

export default component.exports